module.exports = __webpack_public_path__ + "img/disanxian.dd447b9e.jpeg";